<template>
    <Card :bordered="false" class="border-radius-0" :class="{'ant-card-body-p-0': isChildren }">
        <CTable
                :isLoading="isLoading"
                v-model:columns="state.columns"
                v-model:page="state.page"
                :options="state.tableOptions"
                :manages="state.manages"
                :manageExtras="state.manageExtras"
                :rowActions="state.rowActions"
                @search="(search) => onSearch({ props, ...search })"
        ></CTable>
    </Card>
</template>

<script>
    import { defineAsyncComponent, defineComponent, reactive } from 'vue';
    import { Card } from "ant-design-vue";
    import { state as stateApp } from '../../../../app.logic';
    import { state, onSearch, initState, isLoading  } from './work-time-report.logic'

    export default defineComponent({
        components: {
            Card,
            CTable: defineAsyncComponent(() => import('../../../../components/table/CTable'))
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            viewOnly: {},
            visibleSearch: { default: false },
            visiblePagination: { default: false },
            refLabTypeKey: {}
        },
        setup(props) {
            const data = reactive({});
            const refs = reactive({});
            initState({ props, data, refs });
            return { props, data, refs, isLoading, state, onSearch };
        }
    });
</script>